import React from 'react';
import ModalComponent from 'components/common/ModalComponent';
import SelectComponent from 'components/common/SelectComponent';
import PropTypes from 'prop-types';

const StickersModal = ({
  isOpen,
  onClose,
  onSave,
  selectedSticker,
  stickerTypes,
  reusePolicies,
  containers,
  workers
}) => {
  if (!isOpen) return null;

  const isEdit = !!selectedSticker;

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? 'Update Sticker' : 'New Sticker'}
      initialData={{
        stickerType: selectedSticker?.stickerType || '',
        quantity: selectedSticker?.quantity || '',
        reusePolicy: selectedSticker?.reusePolicy || '',
        containerId: selectedSticker?.containerId || '',
        workerId: selectedSticker?.workerId || 0,
        resetTime: selectedSticker?.resetTime || '',
        resetEvery: selectedSticker?.resetEvery || ''
      }}
      onSave={onSave}
    >
      {({ formData, handleChange }) => (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-sm font-medium">Sticker Type</span>
              <SelectComponent
                name="stickerType"
                value={formData.stickerType || ''}
                onChange={handleChange}
              >
                <option key="" value="" disabled>
                  Select Option
                </option>
                {Object.values(stickerTypes).map(type => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </SelectComponent>
            </label>
            {formData.stickerType !== stickerTypes.BOX && (
              <label className="block">
                <span className="text-sm font-medium">Worker</span>
                <SelectComponent
                  id="workerId"
                  name="workerId"
                  value={formData.workerId}
                  onChange={handleChange}
                >
                  <option key="" value="" disabled>
                    Select Option
                  </option>
                  {workers.map(worker => (
                    <option key={worker.workerId} value={worker.workerId}>
                      {worker.firstName} {worker.lastName}
                    </option>
                  ))}
                </SelectComponent>
              </label>
            )}
            <label className="block">
              <span className="text-sm font-medium">Reuse Policy</span>
              <SelectComponent
                id="reusePolicy"
                name="reusePolicy"
                value={formData.reusePolicy || ''}
                onChange={handleChange}
              >
                <option key="" value="" disabled>
                  Select Option
                </option>
                {Object.values(reusePolicies).map(policy => (
                  <option key={policy} value={policy}>
                    {policy}
                  </option>
                ))}
              </SelectComponent>
            </label>
            <label className="block">
              <span className="text-sm font-medium">Container Type</span>
              <SelectComponent
                id="containerId"
                name="containerId"
                value={formData.containerId || ''}
                onChange={handleChange}
              >
                <option key="" value="" disabled>
                  Select Option
                </option>
                {containers.map(container => (
                  <option key={container.containerId} value={container.containerId}>
                    {container.containerName}
                  </option>
                ))}
              </SelectComponent>
            </label>
            <label className="block">
              <span className="text-sm font-medium">Sticker Amount</span>
              <input
                type="number"
                name="quantity"
                value={formData.quantity || ''}
                onChange={handleChange}
                className="mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none"
              />
            </label>
            {formData.stickerType !== stickerTypes.BOX && (
              <label className="block">
                <span className="text-sm font-medium">Daily Reset Time</span>
                <input
                  type="time"
                  name="resetTime"
                  value={formData.resetTime || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none"
                />
              </label>
            )}
            {formData.stickerType !== stickerTypes.PERSONAL && (
              <label className="block">
                <span className="text-sm font-medium">Reset Every</span>
                <input
                  type="time"
                  name="resetEvery"
                  value={formData.resetEvery || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none"
                />
              </label>
            )}
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

StickersModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  selectedSticker: PropTypes.object,
  stickerTypes: PropTypes.object,
  reusePolicies: PropTypes.any,
  containers: PropTypes.arrayOf(PropTypes.object),
  workers: PropTypes.arrayOf(PropTypes.object)
};

export default StickersModal;
